import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CreateCityModal from "../../components/Modal/CreateCity/CreateCityModal";
import SelectInput from "../../components/Select/SelectInput";
import CitiesTable from "../../components/Tables/CitiesTable/CitiesTable";
import { Context } from "../../context/context";
import { getCompanies } from "../../services/company-service";

export default function Cities() {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    async function getCompaniesData() {
      const result = await getCompanies(accessToken);
      setCompanies(result);
    }
    getCompaniesData();
  }, [accessToken]);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <Button
          size="medium"
          onClick={() => setOpen(true)}
          style={{ width: "250px" }}
          variant="contained"
          className="new-user"
        >
          Nova Cidade
        </Button>
        <div className="table-container">
          <div className="form-container">
            <SelectInput
              value={selectedCompany}
              name="Selecione uma empresa"
              setValue={setSelectedCompany}
              selectValues={companies}
            />
          </div>
          {selectedCompany && <CitiesTable selectedCompany={selectedCompany} />}
        </div>
      </main>
      {open && <CreateCityModal setOpen={setOpen} open={open} />}
    </>
  );
}
